// @ts-nocheck
import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { notification, Statistic } from 'antd';
import { DatePicker } from '../../components/ant/DatePicker';
import { SectionContent } from '../../components/hoc/common/components/elements';
import Grid, { GridItem } from '../../components/layout/Grid';
import { dashboardApi } from '../../lib/api';
import DashboardCard from './components/DashboardCard';
import CustomStatistic from './components/CustomStatistic';
import DashboardCharts from './components/DashboardCharts';
import { navigate } from '../../lib/routerAdapter';
const DashboardPage = styled.div.withConfig({
  displayName: "Card__DashboardPage",
  componentId: "sc-1xlq1jv-0"
})(["font-size:max(0.5rem,min(calc(0.9vh + 0.5vw),2rem));margin-bottom:2.5em;"]);
const MainStatistic = props => <Statistic groupSeparator=" " decimalSeparator="," {...props} />;
const StyledStatistic = styled(MainStatistic).withConfig({
  displayName: "Card__StyledStatistic",
  componentId: "sc-1xlq1jv-1"
})(["height:100%;display:flex;align-items:center;justify-content:center;"]);
export default () => {
  const [prevData, setPrevData] = useState({});
  const [data, setData] = useState({});
  const [date, setDate] = useState(moment().utc());
  const [maintenancePlan, setMaintenancePlan] = useState();
  const [perfomancePlan, setPerfomancePlan] = useState();
  const fetchData = useCallback(async () => {
    try {
      const data = await dashboardApi.get({
        date: date.toISOString()
      });
      setData(data);
      setMaintenancePlan([{
        name: 'В работе',
        value: data.atWorkPlannedMaintenancesCount,
        color: '#2770FF'
      }, {
        name: 'Регламент',
        value: data.regulationMaintenancesCount,
        color: '#CCDDFF'
      }, {
        name: 'План',
        value: data.plannedMaintenancesCount,
        color: '#7EAAFF'
      }, {
        name: 'Выполнено',
        value: data.donePlannedMaintenancesCount,
        color: '#6FCF97'
      }]);
      setPerfomancePlan([{
        name: 'Запланировано',
        value: 100 - data.maintenancePerformance,
        color: '#A1C1FF'
      }, {
        name: 'Просрочено',
        value: data.maintenancePerformance,
        color: '#17408E'
      }]);
      const prevData = await dashboardApi.get({
        date: moment(date).add('-1', 'd').toISOString()
      });
      setPrevData(prevData);
    } catch (e) {
      notification.error({
        message: e.message
      });
    }
  }, [date]);
  useEffect(() => {
    fetchData().then();
  }, [date, fetchData]);
  return <DashboardPage>
      <SectionContent style={{
      float: 'right'
    }}>
        <DatePicker format="DD.MM.YYYY" value={date} onChange={date => {
        setDate(date || moment());
      }} />
      </SectionContent>
      <SectionContent>
        <Grid cols={12} rows="18% 46% 18% 18%" gutter="1.5em" rowGutter="1em" customStyles={`
            height: 80vh;
            min-height: 600px;
          `}>
          <GridItem span={2}>
            <DashboardCard title="Топливо и ТЖ">
              <StyledStatistic value={data.fuelsAndLiquidsSum} suffix="руб." valueStyle={{
              color: prevData.fuelsAndLiquidsSum >= data.fuelsAndLiquidsSum ? '#27AE60' : '#E9180A',
              fontSize: '1.5em'
            }} />
            </DashboardCard>
          </GridItem>
          <GridItem span={2}>
            <DashboardCard title="Ремонты">
              <StyledStatistic value={data.repairsSum} suffix="руб." valueStyle={{
              color: prevData.repairsSum < data.repairsSum ? '#27AE60' : '#E9180A',
              fontSize: '1.5em'
            }} />
            </DashboardCard>
          </GridItem>
          <GridItem span={2}>
            <DashboardCard title="ТО">
              <StyledStatistic value={data.maintenancesSum} suffix="руб." valueStyle={{
              color: prevData.maintenancesSum < data.maintenancesSum ? '#27AE60' : '#E9180A',
              fontSize: '1.5em'
            }} />
            </DashboardCard>
          </GridItem>
          <GridItem span={2}>
            <DashboardCard title="На линии" titlePosition="bottom">
              <StyledStatistic value={data.onLineTripsCount} valueStyle={{
              color: '#2770FF',
              fontSize: '2em',
              fontWeight: 400
            }} />
            </DashboardCard>
          </GridItem>
          <GridItem span={2}>
            <DashboardCard title="В парке" titlePosition="bottom">
              <StyledStatistic value={data.parkVehiclesCount} valueStyle={{
              color: '#A1C1FF',
              fontSize: '2em',
              fontWeight: 400
            }} />
            </DashboardCard>
          </GridItem>
          <GridItem span={2}>
            <DashboardCard title="На ремонте" titlePosition="bottom">
              <StyledStatistic value={data.maintenanceVehiclesCount} valueStyle={{
              color: '#17408E',
              fontSize: '2em',
              fontWeight: 400
            }} />
            </DashboardCard>
          </GridItem>
          <DashboardCharts maintenancePlan={maintenancePlan} performancePlan={perfomancePlan} maintenancePerformance={data.maintenancePerformance} onPerformanceClick={() => navigate(`/maintenances/journal?isOverdue=true`)} />
          <GridItem cellUnion={{
          gridColumn: '7 / span 6',
          gridRow: '2'
        }}>
            <DashboardCard title="Стиль вождения">
              <Grid gutter="1.2em" cols={3} customStyles={{
              height: '100%'
            }}>
                <GridItem>
                  <CustomStatistic title="Отлично">
                    <StyledStatistic value={data.perfectRatesCount} valueStyle={{
                    color: '#27AE60',
                    fontSize: '2em',
                    fontWeight: 400
                  }} />
                  </CustomStatistic>
                </GridItem>
                <GridItem>
                  <CustomStatistic title="Хорошо">
                    <StyledStatistic value={data.goodRatesCount} valueStyle={{
                    color: '#7EAAFF',
                    fontSize: '2em',
                    fontWeight: 400
                  }} />
                  </CustomStatistic>
                </GridItem>
                <GridItem>
                  <CustomStatistic title="Плохо">
                    <StyledStatistic value={data.badRatesCount} valueStyle={{
                    color: '#E9180A',
                    fontSize: '2em',
                    fontWeight: 400
                  }} />
                  </CustomStatistic>
                </GridItem>
              </Grid>
            </DashboardCard>
          </GridItem>
          <GridItem cellUnion={{
          gridColumn: '7 / span 6',
          gridRow: '3'
        }}>
            <DashboardCard title="Превышение скорости">
              <Grid gutter="1.2em" cols={3} customStyles={{
              height: '100%'
            }}>
                <GridItem>
                  <CustomStatistic title="20-40 км/ч">
                    <StyledStatistic value={data.from20to40Count} valueStyle={{
                    color: '#2770FF',
                    fontSize: '2em',
                    fontWeight: 400
                  }} />
                  </CustomStatistic>
                </GridItem>
                <GridItem>
                  <CustomStatistic title="40-60 км/ч">
                    <StyledStatistic value={data.from40to60Count} valueStyle={{
                    color: '#E9180A',
                    fontSize: '2em',
                    fontWeight: 400
                  }} />
                  </CustomStatistic>
                </GridItem>
                <GridItem>
                  <CustomStatistic title="Выше 60 км/ч">
                    <StyledStatistic value={data.from60Count} valueStyle={{
                    color: '#E9180A',
                    fontSize: '2em',
                    fontWeight: 400
                  }} />
                  </CustomStatistic>
                </GridItem>
              </Grid>
            </DashboardCard>
          </GridItem>
        </Grid>
      </SectionContent>
    </DashboardPage>;
};
